export const RecipeCategoryEnum = {
  Entree: 1,
  Meat_MeatAlt: 7,
  Grain: 2,
  Vegetable: 3,
  Fruit: 4,
  Milk: 5,
  Miscellaneous: 6,
};

export const RecipeCategoryIdMap = {
  1: 'Entree',
  2: 'Grain',
  3: 'Vegetable',
  4: 'Fruit',
  5: 'Milk',
  6: 'Miscelleaneous',
  7: 'Meat/Meat Alt',
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/RecipeCategoryEnum.js